/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listinganalytics1Inputs */

const en_listinganalytics1 = /** @type {(inputs: Listinganalytics1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listing analytics`)
};

const de_listinganalytics1 = /** @type {(inputs: Listinganalytics1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistiken zum Ort`)
};

/**
* | output |
* | --- |
* | "Listing analytics" |
*
* @param {Listinganalytics1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const listinganalytics1 = /** @type {((inputs?: Listinganalytics1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listinganalytics1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listinganalytics1(inputs)
	return de_listinganalytics1(inputs)
});
export { listinganalytics1 as "listingAnalytics" }